export default __webpack_public_path__ + "static/media/question-dissatisfied.33519880.png";